import type { EmailSignature } from '../types/database';

/** The generic API snake-cases nested JSON keys as well as database columns. */
export function normalizeEmailSignatures(value: unknown): EmailSignature[] {
  if (!Array.isArray(value)) return [];
  return value.filter((item): item is Record<string, unknown> => Boolean(item) && typeof item === 'object')
    .map(item => {
      const text = (camel: string, snake = camel): string => {
        const value = item[camel] ?? item[snake];
        return typeof value === 'string' ? value : '';
      };
      return {
        id: text('id'), name: text('name'), fromEmail: text('fromEmail', 'from_email'),
        displayName: text('displayName', 'display_name'), jobTitle: text('jobTitle', 'job_title'),
        company: text('company'), phone: text('phone'), mobile: text('mobile'), website: text('website'),
        accentColor: text('accentColor', 'accent_color') || '#1a56db',
        isDefault: (item.isDefault ?? item.is_default) === true,
        template: item.template === 'contract-group' ? 'contract-group' : 'simple',
      };
    });
}
